import React, { useEffect, useRef, useState } from "react";
import "./Contact.css";

function Contact() {
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({ name: "", mobile: "", email: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => { if (sectionRef.current) observer.unobserve(sectionRef.current); };
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.mobile || !formData.email || !formData.message) {
      setError("Please fill in all fields");
      return;
    }
    setIsSubmitting(true);
    // Simulate sending
    await new Promise((r) => setTimeout(r, 1500));
    setSubmitted(true);
    setFormData({ name: "", mobile: "", email: "", message: "" });
    setIsSubmitting(false);
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <section id="contact" className="contact-modern" ref={sectionRef}>
      <div className="container">
        <div className={`section-header ${isVisible ? "fade-in" : ""}`}>
          <h2 className="section-title-modern">
            Let's Build <span className="gradient-text">Something Great</span>
          </h2>
          <p className="section-subtitle">
            Open to full-time opportunities and exciting collaborations
          </p>
        </div>

        <div className="contact-grid">
          <div className={`contact-info-modern ${isVisible ? "slide-left" : ""}`}>
            <div className="info-card">
              <div className="info-icon">
                <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="currentColor" strokeWidth="2" />
                  <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
                </svg>
              </div>
              <div>
                <h4>Location</h4>
                <p>Phagwara, Punjab, India</p>
                <span className="info-badge">Open to Remote</span>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
                  <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
                  <path d="M3 7l9 6 9-6" stroke="currentColor" strokeWidth="2" />
                </svg>
              </div>
              <div>
                <h4>Email</h4>
                <a href="mailto:ankitprajapati6937@gmail.com">ankitprajapati6937@gmail.com</a>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.11 12 19.79 19.79 0 0 1 2 4.11 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2" />
                </svg>
              </div>
              <div>
                <h4>Phone</h4>
                <a href="tel:+918448337424">+91 8448337424</a>
              </div>
            </div>

            <div className="social-connect">
              <h4>Connect With Me</h4>
              <div className="social-grid">
                <a href="https://github.com/Ankit6937" target="_blank" rel="noopener noreferrer" className="social-card">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                  </svg>
                  <span>GitHub</span>
                </a>
                <a href="https://linkedin.com/in/ankit6937" target="_blank" rel="noopener noreferrer" className="social-card">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                  </svg>
                  <span>LinkedIn</span>
                </a>
              </div>
            </div>
          </div>

          <div className={`contact-form-card ${isVisible ? "slide-right" : ""}`}>
            {submitted ? (
              <div className="success-animation">
                <div className="success-checkmark">
                  <svg viewBox="0 0 52 52" width="80" height="80">
                    <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
                    <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                  </svg>
                </div>
                <h3>Message Sent Successfully!</h3>
                <p>Thank you for reaching out. Ankit will get back to you soon.</p>
                <button onClick={() => setSubmitted(false)} className="btn-back">Send Another Message</button>
              </div>
            ) : (
              <div className="modern-form">
                <div className="form-row">
                  <div className="form-field">
                    <label htmlFor="name">Full Name *</label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Name" />
                  </div>
                  <div className="form-field">
                    <label htmlFor="mobile">Mobile Number *</label>
                    <input type="tel" id="mobile" name="mobile" value={formData.mobile} onChange={handleChange} placeholder="+91 98765 43210" />
                  </div>
                </div>
                <div className="form-field">
                  <label htmlFor="email">Email Address *</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="john@example.com" />
                </div>
                <div className="form-field">
                  <label htmlFor="message">Message *</label>
                  <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows="5" placeholder="Tell me about your project or opportunity..."></textarea>
                </div>
                {error && (
                  <div className="error-message">
                    <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                      <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    {error}
                  </div>
                )}
                <button onClick={handleSubmit} className="submit-btn-modern" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <><span className="spinner"></span>Sending...</>
                  ) : (
                    <>Send Message
                      <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
                        <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
